// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notification-bell path[data-v-0acc9cf0]{fill:#fff!important}.notification-bell-badge[data-v-0acc9cf0]{width:8px;height:8px;position:absolute;border-radius:50%;left:13px!important;top:0;background:#dd1f13}.notification-bell-badge span[data-v-0acc9cf0]{font-size:12px!important}", ""]);
// Exports
module.exports = exports;
